// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-error-tsx": () => import("/opt/buildhome/repo/src/pages/error.tsx" /* webpackChunkName: "component---src-pages-error-tsx" */),
  "component---src-pages-index-tsx": () => import("/opt/buildhome/repo/src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

